import React, { useEffect, useState, useRef } from 'react';
import { useSmartScroll } from '../../hook/use-smart-scroll';

export const SmartScrollTest: React.FunctionComponent = () => {
  const [elements, setElements] = useState<number[]>([]);
  const containerRef = useRef<HTMLDivElement>(null);
  const TARGET_ELEMENT_ID = 'target-element-10';

  // Set up smart scroll to target element 10 when it appears
  useSmartScroll(`#${TARGET_ELEMENT_ID}`, '.scroll-container', true);

  useEffect(() => {
    let count = 0;
    const maxElements = 200; // Create 20 elements total

    const intervalId = setInterval(() => {
      count++;
      setElements((prev) => [...prev, count]);

      // Stop adding elements after reaching max
      if (count >= maxElements) {
        clearInterval(intervalId);
      }
    }, 500);

    return () => clearInterval(intervalId);
  }, []);

  return (
    <div style={{ height: '100vh', overflow: 'auto' }} className="scroll-container" ref={containerRef}>
      <h2>Smart Scroll Test</h2>
      <p>The page will automatically scroll to element #10 when it appears</p>

      {/* Initial spacing to make scrolling visible */}
      <div
        style={{
          height: '10vh',
          background: '#f0f0f0',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        Scroll down to see elements appearing
      </div>

      {elements.map((num) => (
        <div
          key={num}
          id={num === 10 ? TARGET_ELEMENT_ID : `element-${num}`}
          style={{
            height: '200px',
            margin: '20px 0',
            background: num === 10 ? '#ffcc00' : '#e0e0e0',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: '24px',
            borderRadius: '8px',
            boxShadow: num === 10 ? '0 0 15px rgba(255, 204, 0, 0.6)' : 'none',
          }}
        >
          {num === 10 ? <span>🎯 TARGET ELEMENT #{num} 🎯</span> : <span>Element #{num}</span>}
        </div>
      ))}
    </div>
  );
};
